import { Button } from "@radix-ui/themes";
import { Link as NavLink } from "@tanstack/react-router";

import { ErrorPage } from "../../../components/ErrorPage";
import { canAccessPunttDashboard } from "../../../utils/auth";
import { indexRoute } from "../../index/route";

type EmptyTicketsViewProps = {
  onFilesUpload(): void;
};

export function EmptyTicketsView(props: EmptyTicketsViewProps) {
  const { onFilesUpload } = props;

  return (
    <ErrorPage
      title="Nothing to see here. Yet."
      description={
        canAccessPunttDashboard() ? (
          <>
            Visit{" "}
            <NavLink
              className="puntt-link"
              to={indexRoute.to}
              data-testid="empty-tickets-home-link"
            >
              Home
            </NavLink>{" "}
            to start a new project.
          </>
        ) : (
          "Drop files and folders here to start"
        )
      }
      variant="empty"
    >
      {!canAccessPunttDashboard() && (
        <Button
          size="2"
          variant="outline"
          mx="auto"
          color="gray"
          className="max-w-max"
          onClick={onFilesUpload}
          data-auth-trigger="upload-files"
          data-testid="empty-tickets-upload-button"
        >
          Upload File(s)
        </Button>
      )}
    </ErrorPage>
  );
}
